import React from "react";

const ClientLogoSlider = ({ logos }) => {
  const repeatedLogos = [...logos, ...logos];

  return (
    <div className="overflow-hidden py-8 bg-white rounded-card shadow-sm">
      <div className="client-marquee whitespace-nowrap flex items-center gap-8 animate-marquee">
        {repeatedLogos.map((logo, index) => (
          <div
            key={`${logo.name}-${index}`}
            className="inline-flex items-center justify-center min-w-[140px] h-24 p-4 bg-gray-50 rounded-card shadow-sm border border-gray-200"
          >
            <img
              src={logo.image}
              alt={`${logo.name} logo`}
              className="max-h-16 max-w-full object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientLogoSlider;
